import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllPlanTypes, createPlanType, updatePlanType, deletePlanType } from '../api/auth/planTypeService';

function Clinicsolutionupdate() {
    const [data, setData] = useState([]);
    const [values, setValues] = useState({
        plantype: '',
        date: ''
    });
    const [editingId, setEditingId] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const planTypes = await getAllPlanTypes();
            setData(planTypes);
        } catch (error) {
            console.error('Error fetching plan data:', error);
            Swal.fire('Error!', 'There was a problem fetching plan types.', 'error');
        }
    };

    const handleChanges = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDate = new Date().toISOString().split("T")[0];
        const payload = { ...values, date: currentDate };

        try {
            if (editingId) {
                // Update
                await updatePlanType(editingId, payload);
                Swal.fire('Updated!', 'Plan type has been updated.', 'success');
                setEditingId(null);
            } else {
                // Create
                await createPlanType(payload);
                Swal.fire('Created!', 'Plan type added successfully.', 'success');
            }

            setValues({ plantype: '', date: '' });
            fetchData();
        } catch (error) {
            console.error('Error saving plan:', error);
            Swal.fire('Error!', 'There was a problem saving the plan.', 'error');
        }
    };

    const handleEditClick = (item) => {
        setValues({
            plantype: item.plantype,
            date: item.date || ''
        });
        setEditingId(item.id);
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deletePlanType(id);
                    setData(prev => prev.filter(item => item.id !== id));
                    Swal.fire('Deleted!', 'The plan has been deleted.', 'success');
                } catch (error) {
                    Swal.fire('Error!', 'There was a problem deleting the plan.', 'error');
                    console.error('Error deleting plan:', error);
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-4" style={{ marginLeft: '250px' }}>
                <div className="container-fluid">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <h5 className="page-title">Clinic Solution Update / Pricing Type</h5>
                        </div>
                    </div>

                    {/* Pricing Type Form */}
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label">Plan Type</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="plantype"
                                        onChange={handleChanges}
                                        value={values.plantype}
                                        required
                                    />
                                </div>
                                <button type="submit" className="btn btn-primary">
                                    {editingId ? 'Update' : 'Save'}
                                </button>
                                {editingId && (
                                    <button
                                        type="button"
                                        className="btn btn-secondary ms-2"
                                        onClick={() => {
                                            setEditingId(null);
                                            setValues({ plantype: '', date: '' });
                                        }}
                                    >
                                        Cancel
                                    </button>
                                )}
                            </form>
                        </div>
                    </div>

                    {/* Plan Type Table */}
                    <div className="row mt-5">
                        <div className="col-md-12">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Plan Type</th>
                                        <th>Date</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item.id}>
                                            <td>{index + 1}</td>
                                            <td>{item.plantype}</td>
                                            <td>{item.date || 'N/A'}</td>
                                            <td>
                                                <button className="btn btn-primary me-2" onClick={() => handleEditClick(item)}>Edit</button>
                                                <button className="btn btn-danger" onClick={() => handleDelete(item.id)}>Delete</button>
                                            </td>
                                        </tr>
                                    ))}
                                    {data.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center">No Plan Type found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Clinicsolutionupdate;